module.exports = __webpack_public_path__ + "static/media/vendaMaisWhastappBusinessGoogleMeuNegocio.186d43ca.png";